/* unplugin-vue-components disabled */import script from "./agreement.vue?vue&type=script&setup=true&lang=js"
export * from "./agreement.vue?vue&type=script&setup=true&lang=js"

import "./agreement.vue?vue&type=style&index=0&id=d607262a&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d607262a"]])

export default __exports__